import {
    ADMIN_USER_DELETE_START,
    ADMIN_USER_DELETE_SUCCESS,
    ADMIN_USER_DELETE_FAIL
} from "../constants/type";
import { cloneDeep } from "lodash";
const INITIAL_STATE = {
    isUserDeleteSuccess: false,
    response: null,
    errorMsg: null
};

export default (state = INITIAL_STATE, action) => {
    let currentState = cloneDeep(state);
    switch (action.type) {
        case ADMIN_USER_DELETE_START:
            currentState.isUserDeleteSuccess = false;
            break;
        case ADMIN_USER_DELETE_SUCCESS:
            currentState.isUserDeleteSuccess = true;
            currentState.response = action.payload;
            break;
        case ADMIN_USER_DELETE_FAIL:
            currentState.isUserDeleteSuccess = false;
            currentState.errorMsg = action.payload;
            break;
        default:
            return currentState;
    }
    return currentState;
};
